<template>
  <div class="history">
    <el-card class="box-card">
      <div slot="header">
        <el-row style="display: flex; align-items: center">
          <el-col :span="4">
            <span>总绩效统计</span>
          </el-col>
          <el-col :span="12"> &nbsp; </el-col>
          <!-- 月份选择 + 确认绩效 -->
          <el-col :span="8" style="display: flex; align-items: center; gap: 8px;">
            <el-date-picker
              v-model="monthPicker"
              value-format="yyyy-MM"
              format="yyyy-MM"
              type="month"
              placeholder="选择月份"
              @change="handleMonthChange"
              style="flex: 1;"
            >
            </el-date-picker>
            <el-button type="success" :loading="confirmLoading" @click="handleConfirmPerf">确认绩效</el-button>
            <el-button type="info" :loading="exportLoading" @click="handleExport">导出</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 组长工作量系数 / 行程当量数 -->
      <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 8px;">
        <span style="font-size: 14px; color: #606266;">组长工作量系数：</span>
        <el-input-number
          v-model="leaderCoeff"
          :min="1"
          :max="2"
          :step="0.1"
          :precision="1"
          style="width: 200px;"
        ></el-input-number>
        <span style="font-size: 14px; color: #606266;">行程当量数：</span>
        <el-input-number
          v-model="mileageDayCap"
          :min="0"
          :max="10"
          :step="1"
          :precision="1"
          style="width: 200px;"
        ></el-input-number>
        <el-button type="primary" @click="listTotalPerfWorkload">计算</el-button>
      </div>

      <!-- 月人均日检测检查工作量 & 月人均有效工作量 -->
      <div
        v-if="perfData.length > 0"
        style="
          background: #ecf5ff;
          border: 1px solid #b3d8ff;
          border-radius: 6px;
          padding: 14px 20px;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        "
      >
        <div style="display: flex; align-items: center">
          <span
            style="
              font-size: 15px;
              font-weight: bold;
              color: #409eff;
              margin-right: 12px;
            "
            >月人均日检测检查工作量</span
          >
          <span style="font-size: 13px; color: #606266">
            = 总当量之和（{{ Number(totalCheckInspectEquiv).toFixed(4) }}）/
            总工作人天数（{{ Number(totalWorkDaysSum).toFixed(4) }}）
          </span>
          <span
            style="
              font-size: 16px;
              font-weight: bold;
              color: #e6a23c;
              margin-left: 12px;
              background: #fdf6ec;
              padding: 2px 12px;
              border-radius: 4px;
            "
          >
            {{ Number(avgDailyCheckInspectEquiv).toFixed(4) }}
          </span>
        </div>
        <div style="display: flex; align-items: center">
          <span
            style="
              font-size: 15px;
              font-weight: bold;
              color: #409eff;
              margin-right: 12px;
            "
            >月人均有效工作量</span
          >
          <span style="font-size: 13px; color: #606266">
            = 有效工作量之和（{{ Number(totalEffectiveWorkload).toFixed(4) }}）/
            参与考核人数（{{ assessmentPersonCount }}）
          </span>
          <span
            style="
              font-size: 16px;
              font-weight: bold;
              color: #e6a23c;
              margin-left: 12px;
              background: #fdf6ec;
              padding: 2px 12px;
              border-radius: 4px;
            "
          >
            {{ Number(avgEffectiveWorkload).toFixed(4) }}
          </span>
        </div>
      </div>

      <!-- 总绩效表格 -->
      <el-table :data="perfData" border style="width: 100%">
        <el-table-column
          label="姓名"
          prop="personName"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column label="工作天数" min-width="100" align="center">
          <template slot-scope="scope">{{
            Number(scope.row.workDays).toFixed(0)
          }}</template>
        </el-table-column>
        <el-table-column label="检测当量数" min-width="120" align="center">
          <template slot-scope="scope">{{
            Number(scope.row.checkEquivalentUnits).toFixed(4)
          }}</template>
        </el-table-column>
        <el-table-column label="检查当量数" min-width="120" align="center">
          <template slot-scope="scope">{{
            Number(scope.row.inspectEquivalentUnits).toFixed(4)
          }}</template>
        </el-table-column>
        <el-table-column label="行程当量数" min-width="120" align="center">
          <template slot-scope="scope">{{
            Number(scope.row.mileageEquivalentUnits).toFixed(4)
          }}</template>
        </el-table-column>
        <el-table-column label="行驶里程(km)" min-width="120" align="center">
          <template slot-scope="scope">{{
            Number(scope.row.mileage || 0).toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column label="科技工作量" min-width="120" align="center">
          <template slot-scope="scope">{{
            Number(getTechWorkload(scope.row)).toFixed(4)
          }}</template>
        </el-table-column>
        <el-table-column label="总当量数" min-width="120" align="center">
          <template slot-scope="scope">{{
            Number(getTotalEquiv(scope.row)).toFixed(4)
          }}</template>
        </el-table-column>
        <el-table-column label="质量安全系数" min-width="120" align="center">
          <template slot-scope="scope">{{
            Number(scope.row.safetyCoefficient).toFixed(4)
          }}</template>
        </el-table-column>
        <el-table-column label="有效工作量" min-width="120" align="center">
          <template slot-scope="scope">{{
            Number(scope.row.effectiveWorkload).toFixed(4)
          }}</template>
        </el-table-column>
        <el-table-column label="工作量得分" min-width="110" align="center">
          <template slot-scope="scope">{{
            getWorkloadScore(scope.row)
          }}</template>
        </el-table-column>
        <el-table-column label="个人月绩效值" min-width="120" align="center">
          <template slot-scope="scope">{{
            getMonthlyPerformance(scope.row)
          }}</template>
        </el-table-column>
        <el-table-column label="绩效等级" min-width="90" align="center">
          <template slot-scope="scope">
            <span :style="getGradeStyle(scope.row)">{{
              getPerformanceGrade(scope.row)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="工作态度评分" min-width="130" align="center">
          <template slot-scope="scope">{{
            getAttitudeScore(scope.row)
          }}</template>
        </el-table-column>
        <el-table-column label="工作态度等级" min-width="110" align="center">
          <template slot-scope="scope">
            <span :style="getAttitudeGradeStyle(scope.row)">{{
              getAttitudeGrade(scope.row)
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { queryTotalPerfWorkload, confirmPerf, exportTotalPerfWorkload } from '@/api/workload'
import fileDownload from 'js-file-download'
export default {
  data() {
    return {
      monthPicker: this.getLastMonthStr(),
      perfData: [],
      confirmLoading: false,
      exportLoading: false,
      leaderCoeff: 1.1,
      // 行程当量数（单日里程折算当量封顶，默认 3 台）
      mileageDayCap: 3
    }
  },
  computed: {
    // 月人均日检测检查工作量：所有个人(检测当量+检查当量)之和 / 总工作人天数
    totalCheckInspectEquiv() {
      if (!this.perfData || this.perfData.length === 0) return 0
      return this.perfData.reduce((sum, row) => {
        return (
          sum +
          (Number(row.checkEquivalentUnits) || 0) +
          (Number(row.inspectEquivalentUnits) || 0)
        )
      }, 0)
    },
    totalWorkDaysSum() {
      if (!this.perfData || this.perfData.length === 0) return 0
      return this.perfData.reduce((sum, row) => {
        return sum + (Number(row.workDays) || 0)
      }, 0)
    },
    avgDailyCheckInspectEquiv() {
      if (this.totalWorkDaysSum === 0) return '0.00'
      var val = this.totalCheckInspectEquiv / this.totalWorkDaysSum
      return Math.floor(val * 10000) / 10000
    },
    // 有效工作量之和（所有人的 effectiveWorkload 相加）
    totalEffectiveWorkload() {
      if (!this.perfData || this.perfData.length === 0) return 0
      var sum = 0
      for (var i = 0; i < this.perfData.length; i++) {
        sum += Number(this.perfData[i].effectiveWorkload) || 0
      }
      return sum
    },
    // 参与考核人数 = 工作天数 > 1 的人数
    assessmentPersonCount() {
      if (!this.perfData || this.perfData.length === 0) return 0
      var count = 0
      for (var i = 0; i < this.perfData.length; i++) {
        if (Number(this.perfData[i].workDays) > 1) {
          count++
        }
      }
      return count
    },
    // 月人均有效工作量 = 有效工作量之和 / 参与考核人数
    avgEffectiveWorkload() {
      if (this.assessmentPersonCount === 0) return 0
      var val = this.totalEffectiveWorkload / this.assessmentPersonCount
      return Math.floor(val * 10000) / 10000
    }
  },
  methods: {
    // 获取上个月 yyyy-MM
    getLastMonthStr() {
      let date = new Date()
      date.setDate(0)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      return [y, m].join('-')
    },
    // 选择月份事件
    handleMonthChange(val) {
      if (val == null) {
        this.monthPicker = this.getLastMonthStr()
      }
      this.listTotalPerfWorkload()
    },
    // 获取总绩效数据
    listTotalPerfWorkload() {
      var data = {
        reviewMonth: this.monthPicker || this.getLastMonthStr(),
        leaderCoeff: this.leaderCoeff || 1.1,
        mileageDayCap: this.mileageDayCap == null ? 3 : this.mileageDayCap
      }
      queryTotalPerfWorkload(data).then((res) => {
        if (res.code == 200) {
          this.perfData = res.data.rows || []
          // 按个人月绩效值从大到小排序
          this.sortPerfDataByPerformance()
        }
      })
    },
    // 确认绩效：将绩效值、绩效等级同步到 t_members_wages_info 表
    handleConfirmPerf() {
      var month = this.monthPicker || this.getLastMonthStr()
      this.$confirm('确认将 ' + month + ' 月的绩效值和绩效等级同步到工资明细表？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmLoading = true
        confirmPerf({
          reviewMonth: month,
          leaderCoeff: this.leaderCoeff || 1.1,
          mileageDayCap: this.mileageDayCap == null ? 3 : this.mileageDayCap
        }).then((res) => {
          this.confirmLoading = false
          if (res.code == 200) {
            this.$message({ type: 'success', message: '绩效确认成功' })
          } else {
            this.$message({ type: 'error', message: res.msg || '绩效确认失败' })
          }
        }).catch(() => {
          this.confirmLoading = false
        })
      }).catch(() => {})
    },
    // 导出：导出与列表一致的数据
    handleExport() {
      var month = this.monthPicker || this.getLastMonthStr()
      this.exportLoading = true
      exportTotalPerfWorkload({
        reviewMonth: month,
        leaderCoeff: this.leaderCoeff || 1.1,
        mileageDayCap: this.mileageDayCap == null ? 3 : this.mileageDayCap
      })
        .then((res) => {
          this.exportLoading = false
          fileDownload(res, '总绩效统计_' + month + '.xlsx')
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    // 计算个人的科技工作量 = 科技工作天数 × 月人均日检测检查工作量
    getTechWorkload(row) {
      var days = Number(row.techWorkDays) || 0
      if (
        days === 0 ||
        !this.avgDailyCheckInspectEquiv ||
        this.avgDailyCheckInspectEquiv === '0.00'
      )
        return '0.00'
      var val = days * Number(this.avgDailyCheckInspectEquiv)
      return Math.floor(val * 10000) / 10000
    },
    // 计算个人的总当量数 = 检测当量数 + 检查当量数 + 行程当量数 + 科技当量数
    getTotalEquiv(row) {
      var check = Number(row.checkEquivalentUnits) || 0
      var inspect = Number(row.inspectEquivalentUnits) || 0
      var mileage = Number(row.mileageEquivalentUnits) || 0
      var tech = Number(this.getTechWorkload(row)) || 0
      var val = check + inspect + mileage + tech
      return Math.floor(val * 10000) / 10000
    },
    // 计算个人工作量得分 = 个人月有效工作量 * 100 / 月人均有效工作量，最高不超过130
    getWorkloadScore(row) {
      var effective = Number(row.effectiveWorkload) || 0
      var avgEffective = Number(this.avgEffectiveWorkload) || 0
      if (effective === 0 || avgEffective === 0) return '0.00'
      var score = (effective * 100) / avgEffective
      if (score > 130) score = 130
      return Math.floor(score * 10000) / 10000
    },
    // 计算个人工作态度评分 = 同事互评分(finalScore) * 40% + 客观纪律分(leaderScore) * 60%
    getAttitudeScore(row) {
      var finalScore = Number(row.finalScore) || 0
      var leaderScore = Number(row.leaderScore) || 0
      var score = finalScore * 0.4 + leaderScore * 0.6
      return Math.floor(score * 10000) / 10000
    },
    // 计算个人月绩效值 = 工作量得分 * 0.9 + 工作态度评分 * 0.1
    getMonthlyPerformance(row) {
      var workloadScore = Number(this.getWorkloadScore(row)) || 0
      var attitudeScore = Number(this.getAttitudeScore(row)) || 0
      var score = workloadScore * 0.9 + attitudeScore * 0.1
      return Math.floor(score * 10000) / 10000
    },
    // 按个人月绩效值从大到小排序
    sortPerfDataByPerformance() {
      var self = this
      this.perfData.sort(function (a, b) {
        var pa = Number(self.getMonthlyPerformance(a)) || 0
        var pb = Number(self.getMonthlyPerformance(b)) || 0
        return pb - pa
      })
    },
    // 获取绩效等级（基于排名百分比）
    getPerformanceGrade(row) {
      var total = this.perfData.length
      if (total === 0) return '-'
      var idx = -1
      for (var i = 0; i < total; i++) {
        if (this.perfData[i] === row) {
          idx = i
          break
        }
      }
      if (idx === -1) return '-'
      var pct = ((idx + 1) / total) * 100
      if (pct <= 15) return '优秀'
      if (pct <= 50) return '良好'
      if (pct <= 90) return '合格'
      return '待改善'
    },
    // 获取各绩效等级对应的样式表
    gradeStylesMap() {
      return {
        优秀: {
          background: '#f0f9eb',
          color: '#67c23a',
          fontWeight: 'bold',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block'
        },
        良好: {
          background: '#ecf5ff',
          color: '#409eff',
          fontWeight: 'bold',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block'
        },
        合格: {
          background: '#fdf6ec',
          color: '#e6a23c',
          fontWeight: 'bold',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block'
        },
        待改善: {
          background: '#fef0f0',
          color: '#f56c6c',
          fontWeight: 'bold',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block'
        }
      }
    },
    // 获取绩效等级对应的样式
    getGradeStyle(row) {
      var grade = this.getPerformanceGrade(row)
      return this.gradeStylesMap()[grade] || {}
    },
    // 获取工作态度等级（按工作态度得分从高到低排名，百分比分级逻辑与绩效等级一致）
    getAttitudeGrade(row) {
      var total = this.perfData.length
      if (total === 0) return '-'
      // 按工作态度得分从高到低排序（不改变原始表格顺序）
      var sorted = this.perfData.slice().sort((a, b) => {
        return (Number(this.getAttitudeScore(b)) || 0) - (Number(this.getAttitudeScore(a)) || 0)
      })
      var idx = sorted.indexOf(row)
      if (idx === -1) return '-'
      var pct = ((idx + 1) / total) * 100
      if (pct <= 15) return '优秀'
      if (pct <= 50) return '良好'
      if (pct <= 90) return '合格'
      return '待改善'
    },
    // 获取工作态度等级对应的样式
    getAttitudeGradeStyle(row) {
      var grade = this.getAttitudeGrade(row)
      return this.gradeStylesMap()[grade] || {}
    }
  },
  mounted() {
    // 支持从路由 query 传入月份
    if (this.$route.query && this.$route.query.month) {
      this.monthPicker = this.$route.query.month
    }
    this.listTotalPerfWorkload()
  }
}
</script>

<style lang="scss" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-card__header {
  background: #ebf0f6;
}
</style>
